import React, { useState, useRef, useEffect } from "react";
import { Icon } from "semantic-ui-react";
import "./NewChecklistButton.scss";

// Botón reutilizable "Crear checklist propio". En Figma hay dos modales
// distintos (uno para derivación Manual, otro para Automática) pero con los
// mismos campos salvo ese bloque — en vez de duplicar el componente, este
// botón despliega un mini menú para elegir el modo ANTES de abrir el modal,
// y ese modo llega fijo (ya no editable adentro) a ChecklistTemplateForm.
export function NewChecklistButton({ onSelect, className, children, align = "left" }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onDocClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, [open]);

  const choose = (mode) => {
    setOpen(false);
    onSelect?.(mode);
  };

  return (
    <div className={`nchl-menu nchl-menu--${align}`} ref={ref}>
      <button type="button" className={className} onClick={() => setOpen((p) => !p)}>
        {children}
      </button>
      {open && (
        <div className="nchl-menu__dropdown">
          <button type="button" className="nchl-menu__item" onClick={() => choose("manual")}>
            <Icon name="hand pointer outline" />
            Checklist manual
          </button>
          <button type="button" className="nchl-menu__item" onClick={() => choose("auto")}>
            <Icon name="bolt" />
            Checklist automático
          </button>
        </div>
      )}
    </div>
  );
}
